(function () {
    'use strict';

    angular
        .module('procedureModule')
        .controller('IAMSystemModalController', Controller);

    Controller.$inject = ['$scope', 'searchService', 'iamSystemService', 'notificationService'];

    function Controller($scope, searchService, iamSystemService, notificationService) {
        $scope.ctxSelection = {
            searchTerm: null
        };

        $scope.searchIAMSystem = function (searchTerm) {
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableIAMSystem = [];
                return;
            }
            searchService
                .searchIAMSystem(searchTerm, true)
                .then(function (foundSystem) {
                    if (foundSystem && foundSystem.Results) {
                        $scope.availableIAMSystem = foundSystem.Results;
                    } else {
                        $scope.availableIAMSystem = [];
                    }
                });
        };

        $scope.getIAMSystem = function (iamSystem) {

            iamSystemService
                .getBySlug(iamSystem.Slug)
                .then(function (foundSystem) {
                    if (!foundSystem) {
                        notificationService.warn('This IAM System is not yet available in GOV');
                        return;
                    }
                    $scope.onSelectIAMSystem(foundSystem);
                });
        };

        
    }
})();